import React from 'react';
import translate from '../../../utils/translate';
import headerActions from '../../../actions/header';
import CategoryLink from './category';
import More from './more';

export default class MinorCategories extends React.Component {
  static propTypes = {
    categories:     React.PropTypes.array,
    activeCategory: React.PropTypes.number,
    nested:         React.PropTypes.bool
  };

  getActiveCategoryData = () => {
    // TODO: use array.filter
    for (let i = 0; i < this.props.categories.length; ++i) {
      const cat = this.props.categories[i];
      if (cat.id === this.props.activeCategory) {
        return cat;
      }
    }
  };

  closePanel = () => {
    headerActions.toggleMidPanel();
  };

  renderLinks = () => {
    const activeCategoryData = this.getActiveCategoryData();

    if (activeCategoryData) {
      return activeCategoryData.minor.map((cat, idx) => {
        return <CategoryLink key={cat.id} {...cat} majorCategoryIndex={activeCategoryData.index} />;
      });
    }
  };

  renderSeeAllLink = () => {
    const activeCategoryData = this.getActiveCategoryData() || '#';

    return (
      <div className="header__panel__showall" data-component="header__panel__showall">
        <a
          href={activeCategoryData.categoryResultsPage}
          className="header__panel__showall__link--primary">
          {translate('categoryNavigationModule', 'SEE_ALL_BY_CATEGORY_' + this.props.activeCategory)}
        </a>
      </div>
    );
  };

  render () {
    if (this.props.activeCategory === 'more') {
      return <More {...this.props} />;
    }

    const containerClass = this.props.nested
    ? 'minorcategories--nested'
    : 'minorcategories';
    const activeCategoryData = this.getActiveCategoryData() || '#';
    return (
      <div className={containerClass} data-component="headerMinorCategoryPanel">
        <h3 className="header__panel__title" data-component="minorCategoryPanelHeader">
          <a
            href={activeCategoryData.url}
            className="header__panel__title__link"
            data-component="minorCategoryPanelHeaderButton">
            {activeCategoryData.name}
          </a>
        </h3>
        <ul className="minorcategories__list">
          {this.renderLinks()}
        </ul>
        {this.renderSeeAllLink()}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./frontend/react/components/header/minorcategories/index.js